export function splitStringByCamelCase(string?: string): string | undefined {
	return string?.replace(/\s([A-Z])/g, '$1')
		.replace(/([A-Z-0-9])/g, ' $1')
		.replace(/^./, (str) => str.toUpperCase().trim())
		.trim();
}

export function stringToNormalLock(string?: string): string | undefined {
	return string?.replace(/([A-Z])/g, '$1')
		.trim()
		.split(' ')
		.filter((word: string) => !!word.trim())
		.map((word: string, i: number): string => {
			if (i === 0) {
				return `${word.charAt(0).toUpperCase()}${word.slice(1).toLowerCase()}`;
			}

			return word.toLowerCase();
		})
		.join(' ')
		.trim();
}
